import { useInternalEditorState } from "@circle-react-shared/uikit/TipTap/internalEditorState";
import { Typography } from "@circleco/compass/components/Typography";
import { defer } from "lodash";

import { classNames } from "@/react/helpers/twMergeWithCN";

export interface EmojiItemProps {
  emoji: any;
  index: number;
  insertEmoji: (emoji: any) => void;
  isSelected: boolean;
  setSelectedIndex: (index: number) => void;
}

export const EmojiItemCompass = ({
  emoji,
  index,
  isSelected,
  setSelectedIndex,
  insertEmoji,
}: EmojiItemProps) => {
  const { setPopupsVisible } = useInternalEditorState();

  const onMouseOverOrFocus = () => {
    setSelectedIndex(index);
  };

  return (
    <button
      type="button"
      tabIndex={0}
      id={`emoji-${emoji.id}`}
      key={emoji.id}
      onClick={() => {
        insertEmoji(emoji);
        defer(() => setPopupsVisible(false));
      }}
      onMouseOver={onMouseOverOrFocus}
      onFocus={onMouseOverOrFocus}
      className={classNames(
        "flex w-full cursor-pointer items-center space-x-2 p-2 hover:bg-hover rounded-md",
        {
          "bg-active": isSelected,
        },
      )}
    >
      <Typography variant="body-sm">{emoji.skins[0].native}</Typography>
      <Typography variant="body-sm" truncate>
        :{emoji.id}:
      </Typography>
    </button>
  );
};
